// Adapter wrapping the generated client to preserve the existing API surface.
import { getFormConfigBySlug as genGetFormConfigBySlug, presignUpload as genPresignUpload, submitFormBySlug as genSubmitForm, } from "./generated/client";
import { buildAuthHeaders } from "./custom-mutator";
import { FormConfigSchema, PresignResponseSchema } from "./validators";
export function createFormsApiClient(opts) {
    const base = opts.baseUrl.replace(/\/$/, "").replace(/\/api\/?$/, "");
    const defaultHeaders = opts.defaultHeaders
        ? { ...opts.defaultHeaders }
        : undefined;
    const common = {
        baseUrl: base,
    };
    if (defaultHeaders)
        common.headers = defaultHeaders;
    const isSuccess = (status) => status >= 200 && status < 300;
    return {
        getDefaultHeaders() {
            return defaultHeaders ? { ...defaultHeaders } : {};
        },
        buildAuthHeaders(method) {
            const headers = buildAuthHeaders(method, defaultHeaders);
            const out = {};
            headers.forEach((value, key) => {
                out[key] = value;
            });
            return out;
        },
        async getFormBySlug(org, slug) {
            const res = await genGetFormConfigBySlug(org, slug, common);
            if (opts.validateResponses) {
                try {
                    // Allow partials from backend; validate shape loosely
                    FormConfigSchema.partial().parse(res.data);
                }
                catch (e) {
                    opts.onValidationError?.(e, {
                        op: "getFormBySlug",
                        status: res.status,
                    });
                }
            }
            return {
                status: res.status,
                data: isSuccess(res.status)
                    ? res.data
                    : null,
            };
        },
        async submitFormBySlug(org, slug, body) {
            const res = await genSubmitForm(org, slug, body, common);
            // No response body schema to validate here; backend may return empty 200
            return res;
        },
        async presignUpload(org, slug, req) {
            const res = await genPresignUpload(org, slug, req, common);
            const ok = isSuccess(res.status);
            if (opts.validateResponses && ok && res.data) {
                try {
                    PresignResponseSchema.parse(res.data);
                }
                catch (e) {
                    opts.onValidationError?.(e, {
                        op: "presignUpload",
                        status: res.status,
                    });
                }
            }
            return { status: res.status, data: ok ? res.data ?? null : null };
        },
    };
}
